import React from 'react';

import moduleMetas from 'modules';

// loading the sass style fot the component
import css from './styles.module.scss';

/**
 * Atom DynamicPicker
 * 
 * A picker to dynamically use existing modules.
 */
function DynamicPicker (props) {

  const [Mod, setMod] = React.useState(null);

  const {
    className = "",
    children,
    name,
    src,
    apis,
    ...other
  } = props;

  React.useEffect(_ => {
    (import(`modules/${moduleMetas?.available?.[src || name]?.fileName}/picker/index.js`))
      .then((result) => {
        setMod({
          Comp: result.default
        });
      }).catch((err) => {
        // no picker available
      });
  }, []);

  return <div
    className={`${css["atom__dynamic-picker-container"]} ${className}`}
    {...other}
  >
    {
      Mod && (
        <Mod.Comp
          name={name}
          apis={apis}
          search={other?.value?.title}
          {...other}
        />
      )
    }
    {children}
  </div>;
}

export default DynamicPicker;
